import { Box, Button } from '@mui/material';

interface ErrorMessageCardProps {
  message: string;
  backButtonText: string;
  backButtonAction: () => void;
}

function ErrorMessageCard({
  message,
  backButtonText,
  backButtonAction,
}: ErrorMessageCardProps) {
  return (
    <main className="d-flex w-100 h-100 login-background">
      <div className="container d-flex flex-column">
        <div className="vh-100">
          <div className="mx-auto d-table h-100 w-50">
            <div className="d-table-cell align-middle">
              <Box className="mb-0" style={{ fontSize: '0.8rem' }}>
                <Box className="card">
                  <Box className="card-body">
                    <h3 className="mx-auto text-center mb-3">{message}</h3>
                    <Box>
                      <Button
                        sx={{
                          width: '100%',
                          fontSize: '0.8rem',
                        }}
                        onClick={backButtonAction}
                        variant="outlined"
                        className="btn-outline-secondary"
                      >
                        {backButtonText}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ErrorMessageCard;
